import React from "react";
import NearbyLocationMapTooltip from "./components/NearbyLocationMapTooltip";
import WardMapTooltip from "./components/WardMapTooltip";
import PolygonMapTooltip from "./components/PolygonMapTooltip";

type MapToolTipsProps = {
  state: any;
  onClose: () => void;
};

const MapToolTips = ({ state, onClose }: MapToolTipsProps) => {
  const {
    pointerX,
    pointerY,
    nearbyLocationHoveredObject,
    wardHoveredObject,
    planningPolygonHoveredObject,
  } = state;
  return (
    <>
      {planningPolygonHoveredObject && (
        <PolygonMapTooltip
          pointerX={pointerX}
          pointerY={pointerY}
          objectToDisplay={planningPolygonHoveredObject.properties}
        />
      )}
      {nearbyLocationHoveredObject && (
        <NearbyLocationMapTooltip
          onCloseButtonClick={() => {}}
          pointerX={pointerX}
          pointerY={pointerY}
          objectToDisplay={nearbyLocationHoveredObject}
        />
      )}
      {wardHoveredObject && (
        <WardMapTooltip
          pointerX={pointerX}
          pointerY={pointerY}
          objectToDisplay={wardHoveredObject}
          onClose={onClose}
        />
      )}
    </>
  );
};

export default MapToolTips;
